module.exports = __webpack_public_path__ + "img/logo-loader.4ab51473.png";